import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FAQ() {
  const [activeIndex, setActiveIndex] = useState<number | null>(0);
  const faqs = [{
    q: '¿Por qué Demanda Sostenida es diferente de otras soluciones de marketing gastronómico?',
    a: 'Porque fue creado por un dueño de restaurante, no por un marketer de escritorio. Cada estrategia fue probada primero en Bronson Street Food y luego sistematizada para otros negocios gastronómicos.'
  }, {
    q: '¿Cuánto tiempo tomará ver resultados con Demanda Sostenida?',
    a: 'Los primeros resultados se empiezan a ver entre la semana 2 y 4 de implementación. Los resultados más significativos se consolidan entre los 60 y 90 días.'
  }, {
    q: '¿Necesito experiencia previa en marketing para usar Demanda Sostenida?',
    a: 'No. El sistema está diseñado para dueños de restaurantes, no para marketers. Te acompaño en cada paso para que puedas aplicarlo sin conocimientos previos.'
  }, {
    q: '¿Cómo funciona Demanda Sostenida para atraer nuevos comensales?',
    a: 'Combinamos contenido estratégico en redes sociales con campañas de Meta Ads optimizadas para el rubro gastronómico, generando un flujo constante y predecible de nuevos clientes para tu restaurante.'
  }];
  return <section id="faq" className="py-24 bg-gradient-1" data-id="element-46">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-47">
        <div className="text-center mb-16" data-id="element-48">
          <motion.span initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-accent text-sm font-bold tracking-widest uppercase mb-4 block" data-id="element-49">
            PREGUNTAS FRECUENTES
          </motion.span>
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-4xl md:text-5xl font-heading font-bold text-white" data-id="element-50">
            Lo que necesitás saber
          </motion.h2>
        </div>

        <div className="space-y-4" data-id="element-51">
          {faqs.map((faq, idx) => {
          const isActive = activeIndex === idx;
          return <motion.div key={idx} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: idx * 0.1
          }} className={`bg-[#111] border rounded-xl overflow-hidden transition-colors duration-300 ${isActive ? 'border-accent/50' : 'border-white/5'}`} data-id="element-52">
                <button onClick={() => setActiveIndex(isActive ? null : idx)} className="w-full flex items-center justify-between p-6 text-left focus:outline-none" aria-expanded={isActive} data-id="element-53">
                  <span className={`text-lg font-bold pr-8 ${isActive ? 'text-white' : 'text-gray-300'}`} data-id="element-54">
                    {faq.q}
                  </span>
                  <ChevronDown className={`w-6 h-6 flex-shrink-0 transition-transform duration-300 ${isActive ? 'text-accent rotate-180' : 'text-gray-500'}`} data-id="element-55" />
                </button>
                <AnimatePresence data-id="element-56">
                  {isActive && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3,
                ease: 'easeInOut'
              }} data-id="element-57">
                      <div className="p-6 pt-0 text-text-secondary leading-relaxed border-l-2 border-accent ml-6 mb-6" data-id="element-58">
                        {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}